<template>
  <div class="text-col">
    <p>
      NEWS <span class="date">{{obj.date}}</span></p>
    <p class="title"><b v-html="obj.title"></b></p>
    <p class="excerpt" v-html="obj.excerpt"></p>
    <p class="view-more" @click="viewMore"><b>View more ></b></p>
  </div>
</template>

<script>
export default {
  name: 'SlideNews',
  props: [
    'obj',
    'toggleOpenOverlay',
    'index'
  ],
  methods: {
    viewMore(){      
      return this.$emit('toggleOpenOverlay', this.index)
    }
  }
}
</script>
<style lang="scss" scoped>
  .text-col{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: left;
    padding: 0 20px;
    height: 100%;
  }
  p{
    line-height: 20px;
    font-size: 14px;
    &.title{
      font-size: 16px;
      line-height: 20px;
    }
    &.excerpt{
      line-height: 24px;
    }
    .date{
      font-size: 12px;
    }
  }
  .view-more{
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// SlideNews.vue?4c0b0cb9